import { CreditCard, Download, Mail, ShieldCheck } from "lucide-react";
import { gbp } from "../../lib/store";

export const PRODUCT_COPY = {
  "operator-power-prompts": {
    h1: "Operator Power Prompts – Single Track",
    benefit: "Give AI Clearer Instructions. Get Stronger Results.",
    included: [
      "12 operator meta-prompts (brief, upgrade, red-team, compare, compress, decide)",
      "Copy-ready text for ChatGPT, Claude or Gemini — plus Run with AI inside your Stag Vault account",
      "PDF edition of the full track for offline use",
      "Track unlocked permanently on your Stag Vault account",
    ],
  },
  "ebook-builder": {
    h1: "20-in-1 E-Book Builder – Single Track",
    benefit: "Pick one idea. Let every prompt rewrite itself around it.",
    included: [
      "15 workflow prompts that adapt to your idea, audience, tone and platform",
      "20 ready-made e-book concepts to start from",
      "Step-by-step progress saved on your Stag Vault account",
      "Track unlocked permanently on your Stag Vault account",
    ],
  },
};

export function productCopy(product) {
  return PRODUCT_COPY[product?.slug] || {
    h1: `${(product?.name || "").replace(/\s*\(.*?\)\s*$/, "")} – Single Track`,
    benefit: product?.tagline || "",
    included: [`${product?.prompt_count || ""} copy-ready prompts`, "Run with AI inside your Stag Vault account", "Track unlocked permanently on your Stag Vault account"],
  };
}

export function StoreTrustStrip({ product }) {
  const items = [
    [CreditCard, `One-time ${gbp(product.price)} payment`],
    [ShieldCheck, "Secure checkout — Shopify Payments or Stripe"],
    [Download, "Instant digital download"],
    [Mail, "Download link sent by email"],
  ];
  return (
    <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-2 max-w-md" data-testid="store-trust-strip">
      {items.map(([Icon, label]) => (
        <li key={label} className="flex items-center gap-2 text-xs text-zinc-300"><Icon size={13} className="text-purple-400 shrink-0" aria-hidden="true" />{label}</li>
      ))}
    </ul>
  );
}

export function StoreDeliveryFacts({ product }) {
  const copy = productCopy(product);
  return (
    <section className="mt-12 grid gap-px bg-zinc-900 border border-zinc-900 md:grid-cols-2" data-testid="store-delivery-facts">
      <div className="bg-black p-6 md:p-8">
        <h2 className="font-display text-base md:text-lg font-bold text-white">What you get</h2>
        <ul className="mt-4 space-y-2" data-testid="store-included-list">
          {copy.included.map((line) => <li key={line} className="flex gap-3 text-sm text-zinc-300"><span className="text-purple-400" aria-hidden="true">—</span>{line}</li>)}
        </ul>
      </div>
      <div className="bg-black p-6 md:p-8">
        <h2 className="font-display text-base md:text-lg font-bold text-white">How it's delivered</h2>
        <ul className="mt-4 space-y-2 text-sm text-zinc-300" data-testid="store-delivery-list">
          <li>One-time purchase of {gbp(product.price)} — not a subscription.</li>
          <li>Digital product only. Nothing physical will be shipped.</li>
          <li>Delivery is immediate after confirmed payment.</li>
          <li>Your secure download link is also sent by email to the address used at checkout.</li>
        </ul>
        <p className="mt-4 text-xs text-zinc-500" data-testid="store-licence">
          <span className="text-zinc-300 font-semibold">Licence:</span> personal, single-user licence. Use the prompts and their outputs freely in your own projects and client work. Do not resell, redistribute or repackage the prompt text itself.
        </p>
      </div>
    </section>
  );
}
